import axios from 'axios';

const { Network } = require('alchemy-sdk');

// Connect to the Ethereum network

const apiKey = process.env.VUE_APP_ALCHEMY_API_KEY;

export const alchemyConfig = {
  1: {
    // Ethereum chain
    network: Network.ETH_MAINNET
  },
  137: {
    network: Network.MATIC_MAINNET
  }
}

export const getTokenBalanceByWallet = (address, chainId) => {
  const network = alchemyConfig[chainId];
  if(!network) {
    throw new Error('Pass the correct chainId');
  }
  const networks = [network.network];
  let data = {
    "addresses": [
      {
        address,
        networks
      }
    ]
  };

  let config = {
    url: `https://api.g.alchemy.com/data/v1/${apiKey}/assets/tokens/by-address`,
  };

  return axios.post(config.url, data)
}
